import React from "react";
import { Department } from "../../models";

import FindDealerStore from "../../stores/FindDealerStore";
import { observer, inject } from "mobx-react";

interface Props {
  findDealerStore?: FindDealerStore;
}
interface State {}

class FilterDepartmentsDropDown extends React.Component<Props, State> {
  componentDidMount() {
    const { findDealerStore } = this.props;
    findDealerStore.fetchDepartments();
  }
  handleChange = (e) => {
    const { findDealerStore } = this.props;

    findDealerStore.setDepartmentsFilter(e.target.value);
  };
  render() {
    const { departments, departmentsFilter } = this.props.findDealerStore;
    const renderSelect = () => {
      const isChecked = departmentsFilter === "all";
      return (
        <div>
          <div>
            <input
              type="radio"
              name="radio-departments"
              id={`radio-departments-all`}
              value={`all`}
              checked={isChecked}
              onChange={this.handleChange}
            />
            <label htmlFor={`radio-departments-all`}>All departments</label>
          </div>
          {departments.map((department: Department) => {
            const { id, name } = department;
            const isChecked = departmentsFilter === name;
            return (
              <div key={id}>
                <input
                  type="radio"
                  name="radio-departments"
                  id={`radio-departments-${id}`}
                  value={`${name}`}
                  checked={isChecked}
                  onChange={this.handleChange}
                />
                <label htmlFor={`radio-departments-${id}`}>{name}</label>
              </div>
            );
          })}
        </div>
      );
    };
    return (
      <div className="filter-departments-list">
        <p>
          <strong>Which department are you looking for?</strong>
        </p>
        {!!departments && renderSelect()}
      </div>
    );
  }
}

export default inject("findDealerStore")(observer(FilterDepartmentsDropDown));
